import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from '../pages/LoginPage';
import { VerifyOtpPage } from '../pages/VerifyOtpPage';
import { DashboardPage } from '../pages/DashboardPage';
import { ProtectedRoute } from '../routes/ProtectedRoute';
import { TransactionsPage } from '../pages/TransactionsPage';
import { MonthPage } from '../pages/MonthPage';
import { PendingPaymentsPage } from '../pages/PendingPaymentsPage';
import { StakeSnapshotsPage } from '../pages/StakeSnapshotsPage';
import { AuditLogsPage } from '../pages/AuditLogsPage';
import { ProfilePage } from '../pages/ProfilePage';
import { ChangePasswordPage } from '../pages/ChangePasswordPage';

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/verify-otp" element={<VerifyOtpPage />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/transactions" element={<TransactionsPage />} />
        <Route path="/months" element={<MonthPage />} />
        <Route path="/pending-payments" element={<PendingPaymentsPage />} />
        <Route path="/stake-snapshots" element={<StakeSnapshotsPage />} />
        <Route path="/audit-logs" element={<AuditLogsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/change-password" element={<ChangePasswordPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

